<template>
  <ComboBody />
</template>

<script>
import ComboBody from '../molecules/ComboBody.vue'


export default {
  name: 'ComboView',
  components: {
    ComboBody,
  }
}
</script>
